import React from 'react';
import { TableColumn, TableProps } from '@wix/design-system';
import { DragHandleTableCell } from './DragHandleTableCell';

export function createDragHandleColumn(_props: TableProps): TableColumn {
  return {
    key: 'drag-handle',
    dataHook: 'drag-handle',
    title: '',
    width: '14px',
    render: (row) => <DragHandleTableCell id={row.id} />,
  };
}
